import { FromSchema } from '@40seas/entities/common';
import { Address, AddressSchema, Identification, IdentificationSchema } from '@40seas/models';
import { z } from 'zod';

export const BusinessDetailsSchema = z
    .object({
        displayName: z.string().optional(),
        legalName: z.string().optional(),
        website: z.string().optional(),
        email: z.string().optional(),
        phone: z.string().optional(),
        identification: z.array(IdentificationSchema).optional(),
        address: AddressSchema.optional(),
    })
    .strict();

export class BusinessDetails extends FromSchema(BusinessDetailsSchema) {
    displayName?: string;
    legalName?: string;
    website?: string;
    email?: string;
    phone?: string;
    identification?: Identification[];
    address?: Address;
}
